import api from "@/services/api/static.js";
import { useSelector } from "react-redux";

const useStaticData = () => {
	const staticData = useSelector(state => state.staticData.data)
	return staticData
};

export default useStaticData;